/* Extraction du texte d'un PDF côté navigateur (pdfjs-dist, import dynamique pour ne charger la
   lib que si elle sert vraiment). */
export async function extractPdfText(file) {
  const pdfjsLib = await import('pdfjs-dist');
  // Fichier copié tel quel dans public/ (jamais passé par webpack/Babel) : référencé via new
  // URL(..., import.meta.url), CRA transpile ce .mjs comme du code source et casse ses imports
  // internes vers @babel/runtime (chemins absolus du serveur de build, invalides une fois déployés).
  pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;
  const buffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;
  const pages = [];
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const content = await page.getTextContent();
    pages.push(content.items.map((it) => it.str).join(' '));
  }
  return pages.join('\n');
}
